import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { AdminShell } from '@/shared/ui/layout/AdminShell';
import { useCurrentUser } from '@/entities/auth';
import { useStaffLogout } from '@/features/auth';

type Props = { children: ReactNode };

export const AdminShellWrapper = ({ children }: Props) => {
  const { user, me, role } = useCurrentUser();
  const logout = useStaffLogout();
  const navigate = useNavigate();
  if (!user) {
    navigate('/login', { replace: true });
    return null;
  }
  // Prefer the authoritative `/auth/me` payload; fall back to the JWT-decoded
  // stored user (which login persists with username/full_name). Both are
  // optional so the header components own the empty-state copy.
  const fullName = (me?.full_name ?? user.full_name)?.trim();
  const username = me?.username ?? user.username;
  return (
    <AdminShell
      role={user.role}
      fullName={fullName}
      username={username}
      meRole={role}
      onLogout={() => void logout.logout()}
    >
      {children}
    </AdminShell>
  );
};
